import { isNil } from 'lodash';
import { useContext } from 'react';
import { Menu } from '@shared/components/Menu';
import { CardChannelContext } from '@shared/components/blocks/contexts/channel';
import { Entity } from '@shared/data/entity/Entity';
import { API } from '@shared/types/api';
import { i18n } from '@shared/util/i18n';
import { useNavigator } from '@shared/util/navigation';
import { ChannelPermissionsContext } from '@shared/util/permissions/ChannelPermissionsContext';

interface Props {
  entity: Entity;
  workflowTemplate: API.WorkflowTemplateFragment;
}

export function EditMenuItem({ entity, workflowTemplate }: Props) {
  const { canUpdateCard } = useContext(ChannelPermissionsContext);
  const channel = useContext(CardChannelContext);
  const { navigate } = useNavigator();

  if (!canUpdateCard.enabled) {
    return null;
  }

  const onClick = () => {
    const channelSlug = channel?.slug ?? '';
    if (!isNil(entity.navigationViewTemplateId)) {
      navigate('CardUpdate', {
        cardId: entity.id,
        channelSlug,
        workflowTemplateId: workflowTemplate.id,
        templateSlug: entity.navigationViewTemplateId,
      });
    } else {
      navigate('CardDetails', {
        cardId: entity.id,
        channelSlug,
        workflowTemplateId: workflowTemplate.id,
      });
    }
  };

  return <Menu.Item label={i18n('common.edit')} onClick={onClick} />;
}
